// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/builds/t1_vSKCy2/0/lf/aftersell/qdesk-frontend/apps/frontend/src/models/allSessionsModel';
import model_2 from '/builds/t1_vSKCy2/0/lf/aftersell/qdesk-frontend/apps/frontend/src/models/careModel';
import model_3 from '/builds/t1_vSKCy2/0/lf/aftersell/qdesk-frontend/apps/frontend/src/models/emailTicketModel';
import model_4 from '/builds/t1_vSKCy2/0/lf/aftersell/qdesk-frontend/apps/frontend/src/models/presetScriptModel';
import model_5 from '/builds/t1_vSKCy2/0/lf/aftersell/qdesk-frontend/apps/frontend/src/models/saasTicketModel';
import model_6 from '/builds/t1_vSKCy2/0/lf/aftersell/qdesk-frontend/apps/frontend/src/models/userModel';
import model_7 from '/builds/t1_vSKCy2/0/lf/aftersell/qdesk-frontend/apps/frontend/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: "allSessionsModel", model: model_1 },
model_2: { namespace: "careModel", model: model_2 },
model_3: { namespace: "emailTicketModel", model: model_3 },
model_4: { namespace: "presetScriptModel", model: model_4 },
model_5: { namespace: "saasTicketModel", model: model_5 },
model_6: { namespace: "userModel", model: model_6 },
model_7: { namespace: "@@initialState", model: model_7 },
} as const
